import { render, staticRenderFns } from "./LoadStructuresPage.vue?vue&type=template&id=0c6006c0"
import script from "./LoadStructuresPage.vue?vue&type=script&lang=js"
export * from "./LoadStructuresPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports